import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import classNames from "classnames";
import styled from "styled-components";
import { useSelector } from "react-redux";

const SettingSections = ({ isBottomPage }) => {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree.sections,
  }));
  const sections = [
    ["premadeFrames", lang[5]],
    ["frames", lang[0]],
    ["shape", lang[1]],
    ["logo", lang[2]],
    ...(window.self === window.top ? [["templates", lang[3]]] : []),
  ];
  const [activeSection, setactiveSection] = useState(0);

  const scrolToBlock = (id) => {
    document
      .querySelector(`#${id}`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  useEffect(() => {
    let cleanup = false;
    if (isBottomPage) {
      setactiveSection(sections.length - 1);
      return;
    }

    const elements = sections
      .map((item) => document.querySelector(`#${item[0]}`))
      .filter((item) => item !== null);

    const imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !cleanup) {
            setactiveSection(
              sections.findIndex((item) => item[0] === entry.target.id)
            );
          }
        });
      },
      {
        rootMargin: "-50% 0px -50% 0px",
      }
    );
    elements.forEach((item) => imageObserver.observe(item));
    return () => (cleanup = true);
  }, [isBottomPage]);

  return (
    <div className="bg-white rounded-1 overflow-hidden">
      <Row className="px-md-4 py-3 px-4 flex-nowrap overflow-auto">
        {sections.map((item, index) => (
          <CustomCol key={item[0]} className="px-1 px-md-2">
            <div
              className={classNames(
                "d-flex justify-content-center fw-bold py-2 rounded-1 cursor-pointer text-decoration-none fs-7 fs-md-6 text-nowrap",
                {
                  "bg-primary2 text-primary": activeSection === index,
                  "text-black-title bg-dark-gray": activeSection !== index,
                }
              )}
              onClick={() => scrolToBlock(item[0])}
            >
              {index === 2 ? (
                <>
                  <span className="d-inline d-md-none text-truncate px-1">
                    {lang[4]}
                  </span>
                  <span className="d-none d-md-inline text-truncate px-1">
                    {item[1]}
                  </span>
                </>
              ) : (
                item[1]
              )}
            </div>
          </CustomCol>
        ))}
      </Row>
    </div>
  );
};

export default SettingSections;

const CustomCol = styled(Col)`
  width: 20% !important;
  @media (max-width: 575px) {
    min-width: 120px !important;
  }
`;
